import { Injectable, inject } from '@angular/core';
import { NgxPendoService } from 'ngx-pendo';

@Injectable({ providedIn: 'root' })
export class PendoService {
  private ngxPendoService = inject(NgxPendoService);

  constructor() {}
  initPendo() {
    const NEW_USER = 'Neuer Mareon Benutzer';
    try {
      const visitorId = crypto.randomUUID();
      this.ngxPendoService.initialize(
        {
          id: visitorId,
        },
        {
          id: NEW_USER,
        }
      );
    } catch (err) {
      console.log(err);
    }
  }

}
